import { useSelector } from 'react-redux'
import { useMemo } from 'react'
import { getUserRole } from 'src/features/userRole/UserRoleSelector'
import { getConfig } from 'src/features/config/ConfigSelector'
import { getModuleAccess } from 'src/utils/roleAccess'

const DEFAULT_MODULE = 'fw_ai'

/**
 * React hook to get access control configuration for a given module.
 * @param {string} module - The module to evaluate access for (e.g., 'fw_ai').
 * @returns {object} Access configuration for that module and current user role.
 */
export const useModuleAccess = (module = DEFAULT_MODULE) => {
  const roleKey = useSelector(getUserRole())
  const config = useSelector(getConfig('user_role_settings'))

  const access = useMemo(
    () => getModuleAccess(roleKey, config, module),
    [roleKey, config, module]
  )

  return access
}
